import React, { useMemo } from "react";

import { MessageBar, MessageBarType } from "office-ui-fabric-react";
import { SingleItemIndex } from "@heartfulnessinstitute/react-hfn-forms/dist/ui/CrudTemplate/SingleItemIndex";
import { noop } from "sites-common/utils/lodash";
import ConfigSingle from "./config-single";

function Main({ patient, goBack = noop }) {
  const a = useMemo(() => ConfigSingle(patient), [patient]);
  if (!patient) {
    return (
      <MessageBar messageBarType={MessageBarType.error}>Invalid Key</MessageBar>
    );
  }

  return (
    <SingleItemIndex goBack={goBack} pk_val="documents" ConfigSingle={a} />
  );
}

export default React.memo(Main);
